// Mirrors backend NO_DEPENDENTS_SENTINEL in WorkspaceAddressableParam.ts.
// Frontend translates this value to the UI label "Nenhum" on render
// and back to the sentinel on save.
export const NO_DEPENDENTS_SENTINEL = "__NONE__";
export const NENHUM_LABEL = "Nenhum";
